export const DOM_ATTRIBUTES = {
	themeMode: "data-theme-mode",
} as const;
